const validatePassword = (password) => {
  // const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*_?&])[A-Za-z\d@$!%*_?&]{8,}$/
  // if (!regExp.test(password)) { return false }
  return true
}

export default validatePassword
